import type { PlanningProject, PlanningUser } from "@/views/planning/type";

// Default color for initials when no avatar is available
export const DEFAULT_USER_COLOR = "#8b8b8b";

export const normalizePlanningUser = (user: PlanningUser): PlanningUser => {
  return {
    ...user,
    // Map defaultRole.name to role for the filter to work
    role: user.defaultRole?.name ?? user.role ?? null,
  };
};

export const getUserName = (user: PlanningUser) => {
  return `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim() || "Unknown";
};

export const getUserInitials = (user: PlanningUser) => {
  return (
    `${user.firstName?.[0] ?? ""}${user.lastName?.[0] ?? ""}`.toUpperCase() ||
    "??"
  );
};

export const hasUserAvatar = (user: PlanningUser) => {
  return !!user.avatarUrl;
};

export const getUserAvatarUrl = (user: PlanningUser) => {
  return user.avatarUrl ?? null;
};

export const getUserColor = (user: PlanningUser) => {
  return user.color ?? DEFAULT_USER_COLOR;
};

export const getUserCapacity = (user: PlanningUser) => {
  if (!user.workDayHours) {
    return 40;
  }

  return user.workDayHours.reduce((total, hours) => {
    return total + hours;
  }, 0);
};

export const getProjectColor = (project?: PlanningProject | null) => {
  return project?.color ?? DEFAULT_USER_COLOR;
};

export const getProjectName = (
  project?: PlanningProject | null,
  fallback = "Planned time",
) => {
  return project?.name ?? fallback;
};
